import React, { useState } from 'react';
import { withRouter } from "react-router-dom";

import { store } from "react-notifications-component";

import ButtonV2 from '../../../components/button/button_v2';
import ModalGenericV2 from '../../../components/modal/modalGenericV2';

import HeaderV2 from '../../../components/headerV2';
import AcordionCard from '../../../components/acordionCard';
import InputV2 from '../../../components/input/input_v2';

import * as S from './styles';
import api from '../../../services/api';
import { useEffect } from 'react';
import { BodyG, H5, H6 } from '../../../styles/stylesTypography';

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
const CredenciaisDefesas = ({ ...props }) => {
    const [idMt, setIdMt] = useState(null);
    const [idEs, setIdEs] = useState(null);
    const [savedMt, setSavedMt] = useState(false);

    const [codeUserMt, setCodeUserMt] = useState('');
    const [hashSisdev, setHashSisdev] = useState('');
    const [hashSisdevError, setHashSisdevError] = useState(false);

    const [codeUserEs, setCodeUserEs] = useState('');
    const [userEs, setUserEs] = useState('');
    const [passwordEs, setPasswordEs] = useState('');

    const [idScRevenda, setIdScRevenda] = useState(null);
    const [codeUserScRevenda, setCodeUserScRevenda] = useState('');
    const [userScRevenda, setUserScRevenda] = useState('');
    const [passwordScRevenda, setPasswordScRevenda] = useState('');

    const [usuariosDefesas, setUsuariosDefesas] = useState([]);

    const [isLoadingCards, setIsLoadingCards] = useState(true);

    const [showModalHash, setShowModalHash] = useState(false);

    const getDataSisdev = async () => {
        setIsLoadingCards(true);
        try {
            const response = await api.get(`/integracao/homolog/users`);

            if (response.status === 200) {
                const data = Array.isArray(response.data) ? response.data[0] : response.data;
                const usersCompany = data?.usuarios_empresa || [];

                const defesas = data?.usuarios_defesas || [];
                setUsuariosDefesas(defesas);

                if (usersCompany.length > 0) {
                    const userMt = usersCompany.find(item => item.estado === 'MT');
                    const userEs = usersCompany.find(item => item.estado === 'ES');

                    if (userMt) {
                        setIdMt(userMt.id || null);
                        setSavedMt(true);
                        setCodeUserMt(userMt.cod_usuario || '');
                        setHashSisdev(userMt.hash || '');
                    }

                    if (userEs) {
                        setIdEs(userEs.id || null);
                        setCodeUserEs(userEs.cod_usuario || '');
                        setUserEs(userEs.usuario || '');
                        setPasswordEs(userEs.senha || '');
                    }

                    const scUsers = usersCompany.filter(item => item.estado === 'SC');
                    if (scUsers[0]) {
                        setIdScRevenda(scUsers[0].id || null);
                        setCodeUserScRevenda(scUsers[0].cod_usuario || '');
                        setUserScRevenda(scUsers[0].usuario || '');
                        setPasswordScRevenda(scUsers[0].senha || '');
                    }
                } else if (Array.isArray(response.data) && response.data.length > 0) {
                    setIdMt(response.data[0].id || null);
                    setSavedMt(true);
                    setHashSisdev(response.data[0].hash || '');
                }

                return true;
            }
        } catch (err) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            setIsLoadingCards(false);
        }
    };

    const buildPayloadByState = (state) => {
        if (state === 'MT') {
            return {
                ...(idMt ? { id: idMt } : {}),
                estado: 'MT',
                cod_usuario: codeUserMt || null,
                usuario: null,
                senha: null,
                hash: hashSisdev || null,
            };
        }

        if (state === 'ES') {
            return {
                ...(idEs ? { id: idEs } : {}),
                estado: 'ES',
                cod_usuario: codeUserEs || null,
                usuario: userEs || null,
                senha: passwordEs || null,
                hash: null,
            };
        }

        if (state === 'SC_REVENDA') {
            return {
                ...(idScRevenda ? { id: idScRevenda } : {}),
                estado: 'SC',
                cod_usuario: codeUserScRevenda || null,
                usuario: userScRevenda || null,
                senha: passwordScRevenda || null,
                hash: null,
            };
        }

    };

    const handlePostSisdev = async (payload, state) => {
        setIsLoadingCards(true);
       
        try {
            const response = await api.post(`/integracao/homolog/users`, payload);

            if (response.status === 200) {
                if (state === 'MT' && response?.data?.id) setIdMt(response.data.id);
                if (state === 'ES' && response?.data?.id) setIdEs(response.data.id);
                if (state === 'SC_REVENDA' && response?.data?.id) setIdScRevenda(response.data.id);
                if (state === 'MT') setSavedMt(true);

                store.addNotification({
                    title: "Sucesso!",
                    message: "Usuário Sisdev salvo",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });

                await getDataSisdev();
            }
        } catch (err) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            setIsLoadingCards(false);
        }
    };

    const handlePutSisdev = async (id, payload) => {
        setIsLoadingCards(true);

        try {
            const response = await api.put(`/integracao/homolog/users/${id}`, payload);

            if (response.status === 200) {
                store.addNotification({
                    title: "Sucesso!",
                    message: "Usuário Sisdev atualizado com sucesso.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        } catch (err) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            setIsLoadingCards(false);
        }
    };

    useEffect(() => {
        getDataSisdev();
    }, [])

    return (
        <S.Container>
            <HeaderV2 title="Credenciais Defesas" />

            <S.Wrapper>
                {isLoadingCards ? (
                    <S.ContainerLoading>
                        <S.Loading />
                    </S.ContainerLoading>
                    ) : (
                        <S.ContainerAcordions>
                            {usuariosDefesas.length > 0 && <H6>Usuário agrônomo</H6>}

                            {usuariosDefesas.map((usuario) => (
                                <AcordionCard
                                    key={usuario.id}
                                    title={usuario.nome}
                                    isOpen={false}
                                    hasError={false}
                                    hasBlock={false}
                                    accordionKey={`agronomo-${usuario.id}`}
                                >
                                    <S.ContainerAcordionCard>
                                        {(usuario.user_states || []).map((state) => (
                                            <React.Fragment key={state.id}>
                                                <InputV2
                                                    id={`usuario-${state.id}`}
                                                    name={`usuario-${state.id}`}
                                                    type="text"
                                                    label={`${state.defesa} (${state.state}) - Usuário`}
                                                    onChange={() => {}}
                                                    value={state.usuario || ''}
                                                    disabled={true}
                                                    height='auto'
                                                    marginBottom="0"
                                                />
                                                <InputV2
                                                    id={`senha-${state.id}`}
                                                    name={`senha-${state.id}`}
                                                    type="text"
                                                    label={`${state.defesa} (${state.state}) - Senha`}
                                                    onChange={() => {}}
                                                    value={state.senha ? '***' : ''}
                                                    disabled={true}
                                                    height='auto'
                                                    marginBottom="0"
                                                />
                                            </React.Fragment>
                                        ))}
                                    </S.ContainerAcordionCard>
                                </AcordionCard>
                            ))}

                            <H6>Usuário revenda</H6>

                            <AcordionCard
                                title="MT - SISDEV"
                                isOpen={false}
                                hasError={false}
                                hasBlock={false}
                                accordionKey="sisdev-mt"
                            >
                                <S.ContainerAcordionCard>
                                    <InputV2
                                        id='codigoUser'
                                        name="codigoUser"
                                        type="text"
                                        label="Código do usuário"
                                        labelWithAsterisk={true}
                                        onChange={e => { setCodeUserMt(e); setHashSisdevError(false); }}
                                        value={codeUserMt}
                                        erro={hashSisdevError}
                                        height='auto'
                                        marginBottom="0"
                                    />
                                    <InputV2
                                        id='hash'
                                        name="hash"
                                        type="text"
                                        label="Hash"
                                        labelWithAsterisk={true}
                                        onChange={e => { setHashSisdev(e); setHashSisdevError(false); }}
                                        value={hashSisdev}
                                        erro={hashSisdevError}
                                        height='auto'
                                        marginBottom="0"
                                        help={true}
                                        helpClick={() => setShowModalHash(true)}
                                    />
                                    <ButtonV2
                                        width='120px'
                                        height='48px'
                                        disabled={!codeUserMt || !hashSisdev}
                                        value={(idMt || savedMt) ? "Salvar" : "Cadastrar"}
                                        onClick={() => { idMt ? handlePutSisdev(idMt, buildPayloadByState('MT')) : handlePostSisdev(buildPayloadByState('MT'), 'MT'); }}
                                        loading={isLoadingCards}
                                    />
                                </S.ContainerAcordionCard>
                            </AcordionCard>

                            <AcordionCard
                                title="ES - IDAF"
                                isOpen={false}
                                hasError={false}
                                hasBlock={false}
                                accordionKey="idaf-es"
                            >
                                <S.ContainerAcordionCard>
                                    <InputV2
                                        id='codigoUser-es'
                                        name="codigoUser-es"
                                        type="text"
                                        label="Código do usuário"
                                        labelWithAsterisk={true}
                                        onChange={e => setCodeUserEs(e)}
                                        value={codeUserEs}
                                        height='auto'
                                        marginBottom="0"
                                    />
                                    <InputV2
                                        id='user-es'
                                        name="user-es"
                                        type="text"
                                        label="Usuário"
                                        labelWithAsterisk={true}
                                        onChange={e => setUserEs(e)}
                                        value={userEs}
                                        height='auto'
                                        marginBottom="0"
                                    />
                                    <InputV2
                                        id='password-es'
                                        name="password-es"
                                        type="text"
                                        label="Senha"
                                        labelWithAsterisk={true}
                                        onChange={e => setPasswordEs(e)}
                                        value={passwordEs}
                                        height='auto'
                                        marginBottom="0"
                                    />
                                    <ButtonV2
                                        width='120px'
                                        height='48px'
                                        disabled={!codeUserEs || !userEs || !passwordEs}
                                        value={idEs ? "Salvar" : "Cadastrar"}
                                        onClick={() => { idEs ? handlePutSisdev(idEs, buildPayloadByState('ES')) : handlePostSisdev(buildPayloadByState('ES'), 'ES'); }}
                                        loading={isLoadingCards}
                                    />
                                </S.ContainerAcordionCard>
                            </AcordionCard>

                            <AcordionCard
                                title="SC - CIDASC"
                                isOpen={false}
                                hasError={false}
                                hasBlock={false}
                                accordionKey="cidasc-sc"
                            >
                                <S.ContainerAcordionCard>
                                    <InputV2
                                        id='codigoUser-sc-revenda'
                                        name="codigoUser-sc-revenda"
                                        type="text"
                                        label="Código do usuário"
                                        labelWithAsterisk={true}
                                        onChange={e => setCodeUserScRevenda(e)}
                                        value={codeUserScRevenda}
                                        height='auto'
                                        marginBottom="0"
                                    />
                                    <InputV2
                                        id='user-sc-revenda'
                                        name="user-sc-revenda"
                                        type="text"
                                        label="Usuário"
                                        labelWithAsterisk={true}
                                        onChange={e => setUserScRevenda(e)}
                                        value={userScRevenda}
                                        height='auto'
                                        marginBottom="0"
                                    />
                                    <InputV2
                                        id='password-sc-revenda'
                                        name="password-sc-revenda"
                                        type="text"
                                        label="Senha"
                                        labelWithAsterisk={true}
                                        onChange={e => setPasswordScRevenda(e)}
                                        value={passwordScRevenda}
                                        height='auto'
                                        marginBottom="0"
                                    />
                                    <ButtonV2
                                        width='120px'
                                        height='48px'
                                        disabled={!codeUserScRevenda || !userScRevenda || !passwordScRevenda}
                                        value={idScRevenda ? "Salvar" : "Cadastrar"}
                                        onClick={() => { idScRevenda ? handlePutSisdev(idScRevenda, buildPayloadByState('SC_REVENDA')) : handlePostSisdev(buildPayloadByState('SC_REVENDA'), 'SC_REVENDA'); }}
                                        loading={isLoadingCards}
                                    />
                                </S.ContainerAcordionCard>
                            </AcordionCard>
                        </S.ContainerAcordions>
                    )
                }
            </S.Wrapper>

            <ModalGenericV2
                show={showModalHash}
                onHide={() => setShowModalHash(false)}
                marginBottom="0"
            >
                <S.ContainerModal>
                    <H5>Hash da Revenda</H5>

                    <BodyG>
                        O hash da revenda é um código de segurança exclusivo utilizado para autorizar o envio de informações ao sistema do SISDEV.
                        Ele é um identificador da sua revenda dentro da integração, garantindo que apenas estabelecimentos autorizados consigam enviar dados, como as entradas de agrotóxicos.
                    </BodyG>


                    <BodyG>
                        Como obter o hash:
                        O hash é fornecido pelo próprio SISDEV e enviado para o e-mail cadastrado da empresa.
                        Caso você não tenha o hash ou precise gerar um novo, é necessário solicitar diretamente ao órgão responsável:
                    </BodyG>

                    <ul>
                        <li><BodyG>Enviar um e-mail para: sisdev@indea.mt.gov.br</BodyG></li>
                        <li><BodyG>Informar o CNPJ da revenda</BodyG></li>
                        <li><BodyG>Solicitar o hash para o ambiente desejado(produção)</BodyG></li>
                    </ul>
                </S.ContainerModal>
            </ModalGenericV2>
        </S.Container>
    );
};

export default withRouter(CredenciaisDefesas);
